import { atom } from "recoil";

export const addStateOfficeDivision = atom({
  key: "addStateOfficeDivision",
  default: false,
});
export const editStateOfficeDivision = atom({
  key: "editStateOfficeDivision",
  default: false,
});
export const rowEditIdStateOfficeDivision = atom({
  key: "rowEditIdStateOfficeDivision",
  default: null,
});
export const disableButtonStateOfficeDivision = atom({
  key: "disableButtonStateOfficeDivision",
  default: false,
});

export const selectedRowsStateOfficeDivision = atom({
  key: "selectedRowsStateOfficeDivision",
  default: [],
});

export const setFilterTextOfficeDivision = atom({
  key: "setFilterTextOfficeDivision",
  default: "",
});
